import 'jquery-validation';

$(function () {

	/* ==============================
	   Custom Validator: Password Strength
	   ============================== */
	$.validator.addMethod('passwordStrength', function (value) {
		return /[a-z]/.test(value)
			&& /[A-Z]/.test(value)
			&& /[0-9]/.test(value)
			&& /[^a-zA-Z0-9]/.test(value);
	}, window.Lang.val_password_strength);

	/* ==============================
	   Login Form Validation + AJAX
	   ============================== */
	if ($('#loginForm').length) {
		$('#loginForm').validate({
			rules: {
				email: {
					required: true,
					email: true
				},
				password: {
					required: true,
					minlength: 6
				}
			},
			messages: {
				email: {
					required: window.Lang.val_email_required,
					email: window.Lang.val_email_invalid
				},
				password: {
					required: window.Lang.val_password_required,
					minlength: window.Lang.val_password_minlength
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			errorPlacement: function (error, element) {
				error.insertAfter(element.closest('.mb-3, .mb-4').find('label').first());
			},
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');
				$btn.prop('disabled', true);

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					dataType: 'json',
					success: function (res) {
						if (res.status === 'success' && res.redirect) {
							window.location.href = res.redirect;
						} else if (res.status === 'not_verified') {
							var emailToResend = res.email || $form.find('input[name="email"]').val();
							GlobalSwal.fire({
								title: window.Lang.auth_not_verified_title || window.Lang.error_title,
								text: res.msg || res.message || window.Lang.auth_not_verified,
								icon: 'warning',
								showCancelButton: true,
								confirmButtonText: window.Lang.auth_resend_verification || 'Újraküldés',
								cancelButtonText: window.Lang.confirm_button
							}).then(function (result) {
								$btn.prop('disabled', false);
								if (result.isConfirmed) {
									$.ajax({
										url: '/verification/resend',
										method: 'POST',
										data: {
											_token: $form.find('input[name="_token"]').val(),
											email: emailToResend
										},
										dataType: 'json',
										success: function (r2) {
											GlobalSwal.fire({
												title: window.Lang.success_title || '',
												text: r2.msg || window.Lang.auth_resend_sent || '',
												icon: 'success',
												confirmButtonText: window.Lang.confirm_button
											});
										},
										error: function () {
											GlobalSwal.fire({
												title: window.Lang.error_title,
												text: window.Lang.auth_login_error,
												icon: 'error',
												confirmButtonText: window.Lang.confirm_button
											});
										}
									});
								}
							});
						} else if (res.status === 'error') {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: res.msg || res.message || window.Lang.auth_login_bad,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						}
					},
					error: function (xhr) {
						var errors = xhr.responseJSON && xhr.responseJSON.errors;
						if (errors) {
							var msg = Object.values(errors).flat().join('\n');
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: msg,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						} else {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_login_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						}
						$btn.prop('disabled', false);
					}
				});
			}
		});
	}

	/* ==============================
	   Registration Form Validation + AJAX
	   ============================== */
	if ($('#registrationForm').length) {
		$('#registrationForm').validate({
			rules: {
				name: {
					required: true,
					minlength: 2
				},
				email: {
					required: true,
					email: true
				},
				password: {
					required: true,
					minlength: 6,
					passwordStrength: true
				},
				password_confirmation: {
					required: true,
					equalTo: '[name="password"]'
				},
				terms: {
					required: true
				}
			},
			messages: {
				name: {
					required: window.Lang.val_name_required,
					minlength: window.Lang.val_name_minlength
				},
				email: {
					required: window.Lang.val_email_required,
					email: window.Lang.val_email_invalid
				},
				password: {
					required: window.Lang.val_password_required,
					minlength: window.Lang.val_password_minlength,
					passwordStrength: window.Lang.val_password_strength
				},
				password_confirmation: {
					required: window.Lang.val_pw_confirm_required,
					equalTo: window.Lang.val_pw_confirm_mismatch
				},
				terms: {
					required: window.Lang.val_terms_required
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			errorPlacement: function (error, element) {
				if (element.attr('type') === 'checkbox') {
					error.insertAfter(element.closest('.mb-4'));
				} else {
					error.insertAfter(element.closest('.col-6, .mb-3').find('label').first());
				}
			},
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');
				$btn.prop('disabled', true);

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					dataType: 'json',
					success: function (res) {
						if (res.status === 'success' && res.redirect) {
							window.location.href = res.redirect;
						} else if (res.status === 'error') {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: res.msg || res.message || window.Lang.auth_register_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						}
					},
					error: function (xhr) {
						var errors = xhr.responseJSON && xhr.responseJSON.errors;
						if (errors) {
							var msg = Object.values(errors).flat().join('\n');
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: msg,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						} else {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_register_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						}
						$btn.prop('disabled', false);
					}
				});
			}
		});
	}

	/* ==============================
	   Password Reset Form Validation + AJAX
	   ============================== */
	if ($('#passwordResetForm').length) {
		$('#passwordResetForm').validate({
			rules: {
				email: {
					required: true,
					email: true
				}
			},
			messages: {
				email: {
					required: window.Lang.val_email_required,
					email: window.Lang.val_email_invalid
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			errorPlacement: function (error, element) {
				error.insertAfter(element.closest('.mb-4, .mb-3').find('label').first());
			},
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');
				$btn.prop('disabled', true);

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					dataType: 'json',
					success: function (res) {
						if (res.status === 'success') {
							$form.html('<div class="alert alert-success">' + window.Lang.auth_reset_sent + '</div>');
						} else if (res.status === 'error') {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: res.msg || res.message || window.Lang.auth_reset_not_found,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						}
					},
					error: function (xhr) {
						var errors = xhr.responseJSON && xhr.responseJSON.errors;
						if (errors) {
							var msg = Object.values(errors).flat().join('\n');
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: msg,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						} else {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_reset_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						}
						$btn.prop('disabled', false);
					}
				});
			}
		});
	}

	/* ==============================
	   Set New Password Form Validation + AJAX
	   ============================== */
	if ($('#setPasswordForm').length) {
		$('#setPasswordForm').validate({
			rules: {
				password: {
					required: true,
					minlength: 6,
					passwordStrength: true
				},
				password_confirmation: {
					required: true,
					minlength: 6,
					equalTo: '[name="password"]'
				}
			},
			messages: {
				password: {
					required: window.Lang.val_password_required,
					minlength: window.Lang.val_password_minlength,
					passwordStrength: window.Lang.val_password_strength
				},
				password_confirmation: {
					required: window.Lang.val_pw_confirm_required,
					minlength: window.Lang.val_password_minlength,
					equalTo: window.Lang.val_pw_confirm_mismatch
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			errorPlacement: function (error, element) {
				error.insertAfter(element.closest('.mb-3, .mb-4').find('label').first());
			},
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');
				$btn.prop('disabled', true);

				$.ajax({
					url: $form.attr('action'),
					method: 'POST',
					data: $form.serialize(),
					dataType: 'json',
					success: function (res) {
						if (res.status === 'success') {
							$form.html('<div class="alert alert-success">' + window.Lang.auth_pw_changed + ' <a href="' + window.location.origin + '/login">' + window.Lang.auth_pw_changed_login + '</a></div>');
						} else if (res.status === 'wrong_current_password') {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_pw_wrong_current,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						} else if (res.status === 'payload_error') {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_pw_invalid_link,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						} else {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: res.msg || res.message || window.Lang.auth_generic_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
							$btn.prop('disabled', false);
						}
					},
					error: function (xhr) {
						var errors = xhr.responseJSON && xhr.responseJSON.errors;
						if (errors) {
							var msg = Object.values(errors).flat().join('\n');
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: msg,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						} else {
							GlobalSwal.fire({
								title: window.Lang.error_title,
								text: window.Lang.auth_pw_set_error,
								icon: 'error',
								confirmButtonText: window.Lang.confirm_button
							});
						}
						$btn.prop('disabled', false);
					}
				});
			}
		});
	}

	/* ==============================
	   Password Strength Indicator
	   ============================== */
	function initPasswordStrength(inputSelector) {
		var $input = $(inputSelector);
		if (!$input.length) return;

		var $bars = $('<div class="pw-strength-bars">'
			+ '<span class="pw-bar" data-index="0"></span>'
			+ '<span class="pw-bar" data-index="1"></span>'
			+ '<span class="pw-bar" data-index="2"></span>'
			+ '<span class="pw-bar" data-index="3"></span>'
			+ '</div>');

		$bars.css({
			display: 'flex',
			gap: '4px',
			marginTop: '6px'
		});

		$bars.find('.pw-bar').css({
			flex: '1',
			height: '4px',
			borderRadius: '50px',
			background: '#e0e0e0',
			transition: 'background 0.3s'
		});

		var activeColors = ['#dc3545', '#ffc107', '#0d6efd', '#198754'];

		$input.closest('.mb-3, .mb-4, .col-6').append($bars);

		$input.on('input.pwstrength', function () {
			var val = $(this).val();
			var score = [
				/[a-z]/.test(val),
				/[A-Z]/.test(val),
				/[0-9]/.test(val),
				/[^a-zA-Z0-9]/.test(val)
			].filter(Boolean).length;

			$bars.find('.pw-bar').each(function (i) {
				$(this).css('background', i < score ? activeColors[i] : '#e0e0e0');
			});
		});
	}

	if ($('#registrationForm').length) {
		initPasswordStrength('#registrationForm [name="password"]');
	}

	if ($('#setPasswordForm').length) {
		initPasswordStrength('#setPasswordForm [name="password"]');
	}

	/* ==============================
	   Password Toggle (global)
	   ============================== */
	window.togglePassword = function (btn) {
		var input = btn.parentElement.querySelector('input');
		input.type = input.type === 'password' ? 'text' : 'password';
	};
});
